import { ReactElement } from 'react'
import styles from './MobileAboutUsScreen.module.scss'
import { MobileBodyLarge, MobileHeadlineLarge } from '../../Typography'
import { AboutUsScreenData } from './AboutUsScreen'
import { BackgroundSlideshow } from '../../components/background-slideshow/BackgroundSlideshow'

type Props = {
  data: AboutUsScreenData
}

export const MobileAboutUsScreen = ({ data: { backgroundUrls } }: Props): ReactElement => {
  return (
    <div className={styles.container}>
      <BackgroundSlideshow images={backgroundUrls} />
      <MobileHeadlineLarge>Über uns</MobileHeadlineLarge>
      <div className={styles.gaplessBox}>
        <MobileBodyLarge>
          Herzlich Willkommen bei FIGHTBACK-WRESTLING. Pro Wrestling ist eine Leidenschaft, die wir
          mit Euch allen gemeinsam teilen.
        </MobileBodyLarge>
        <MobileBodyLarge>Aus diesem Grund sind wir heute hier.</MobileBodyLarge>
      </div>
      <div className={styles.gaplessBox}>
        <MobileBodyLarge>
          Mit Beginn der Corona Pandemie wurde die Zusammenarbeit zwischen new Generation wrestling
          und German Hurricane Wrestling immer enger.
        </MobileBodyLarge>
        <MobileBodyLarge>
          Der FIGHTBACK-WRESTLING Brand entstand und wurde innerhalb kürzester Zeit ein bekannter
          Name in Wrestling Deutschland.
        </MobileBodyLarge>
        <MobileBodyLarge>
          Zwei etablierte Organisationen haben es sich zur Aufgabe gemacht, die Flagge für Wrestling
          in dieser schweren Zeit hochzuhalten.
        </MobileBodyLarge>
        <MobileBodyLarge>Die Kräfte und Ressourcen von nGw und GHW wurden vereint.</MobileBodyLarge>
      </div>
      <div className={styles.gaplessBox}>
        <MobileBodyLarge>
          Zudem haben eine Kooperation mit dem Wrestling Verband OIWA ins Leben gerufen.
        </MobileBodyLarge>
        <MobileBodyLarge>
          WWE Legende Sir Mo aus Dallas Texas, USA und Promoterin Lindsey Jordan aus England
          arbeiten seitdem sehr eng mit unserem Office zusammen.
        </MobileBodyLarge>
        <MobileBodyLarge>Gemeinsame Shows wurden auf die Beine gestellt.</MobileBodyLarge>
        <MobileBodyLarge>Nicht nur in Deutschland, auch in den USA und England.</MobileBodyLarge>
        <MobileBodyLarge>
          Im September 2024 kam dann direkt der nächste große Schritt.
        </MobileBodyLarge>
        <MobileBodyLarge>
          FIGHTBACK-WRESTLING ist wöchentlich im Fernsehen zu bewundern.
        </MobileBodyLarge>
        <MobileBodyLarge>
          Der OK:TV Mainz gibt uns jeden Sonntag um 22 Uhr eine Plattform.
        </MobileBodyLarge>
        <MobileBodyLarge>
          Zudem werden die FIGHTBACK Episoden auch auf MagentaTV und dem TV-Streaming-Anbieter
          Zattoo ausgestrahlt.
        </MobileBodyLarge>
      </div>
      <MobileBodyLarge>
        Gemeinsam mit Euch, der FIGHTBACK-Community, lassen wir die Hütte brennen.
      </MobileBodyLarge>
      <div className={styles.gaplessBox}>
        <MobileBodyLarge>
          Das FIGHTBACK Office möchte sich in diesem Zusammenhang bei allen Wrestlerinnen und
          Wrestlern, Helfern sowie bei jedem Fan und Zuschauer bedanken.
        </MobileBodyLarge>
        <MobileBodyLarge>Ohne Euch wäre das alles nicht realisierbar.</MobileBodyLarge>
      </div>
      <div className={styles.gaplessBox}>
        <MobileBodyLarge>Vielen Dank.</MobileBodyLarge>
        <MobileBodyLarge>
          Und vergesst nicht: Bei FIGHTBACK-WRESTLING kann alles passieren!
        </MobileBodyLarge>
      </div>
    </div>
  )
}
